import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const themesBeam = createBeam(bifrost, "/themes");
